'use client';

import HeaderShopCart from '@/components/header/header-shop-cart';
import { Languages } from '@/lib/dictionaries';
import { signOut, useSession } from 'next-auth/react';
import Link from 'next/link';

import React from 'react';
import classes from './header.module.scss';

const LoginOrNicknameButton = ({
  lang,
  loginButtonName,
  logoutButtonName,
}: {
  lang: Languages;
  loginButtonName: string;
  logoutButtonName: string;
}) => {
  const session = useSession();

  const handleLogout = async () => {
    await signOut({
      callbackUrl: `${process.env.NEXT_PUBLIC_API_URL}/${lang}`,
    });
  };

  if (session.data && session.data.user && session.data.user.userId) {
    return (
      <div className={classes.logoutBox}>
        <div className={classes.userBox}>{session.data!.user.name}</div>
        <HeaderShopCart
          className="giftifan5 font-medium text-base hidden md:inline-block"
          useIcon={false}
          lang={lang}
        />
        <button className={classes.logoutBtn} onClick={handleLogout}>
          {logoutButtonName}
        </button>
      </div>
    );
  }
  return (
    <div className={classes.loginBox}>
      <Link href={`/${lang}/signin`} className={classes.loginBtn}>
        <span className={classes.loginTxt}>{loginButtonName}</span>
      </Link>
    </div>
  );
};

export default LoginOrNicknameButton;
